import { onMounted, onScopeDispose, ref } from "vue";

type Callback = (isVisible?: boolean) => unknown;


/**
 * Tracks whether the document tab is refocused and invokes an optional callback
 * whenever the tab becomes visible.
 *
 * @param callback Optional callback invoked after the document becomes visible.
 * @returns An object with `isTabInFocus`, a ref that reflects the current tab visibility.
 */
const useVisibilityRefocus = (
    callback?: Callback
) => {

    const isTabInFocus = ref(document.visibilityState === 'visible');

    const handleVisibilityChange = () => {
        isTabInFocus.value = document.visibilityState === 'visible';

        callback?.(isTabInFocus.value);
    }

    onMounted(() => {
        document.addEventListener('visibilitychange', handleVisibilityChange);
    });

    onScopeDispose(() => {
        document.removeEventListener('visibilitychange', handleVisibilityChange);
    });

    return { isTabInFocus };
};

export { useVisibilityRefocus };